module.exports = __webpack_public_path__ + "img/trash-can.9f031b8f.svg";